import axios, { AxiosResponse, CancelToken } from "axios";
import { LogEvent } from "../../models/LogEvents";
import { GetChannelLogsRequest, TwilioChannelResponse } from "../../models/TwilioModels";

export const getTwilioChannelLogsPage =
	(request: GetChannelLogsRequest, productId: string, subscriptionId: string, accountSid: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<TwilioChannelResponse>> => {
		return await axios.post(
			`/api/v1/${productId}/Twilio/ChannelLogs/${subscriptionId}/${accountSid}/GetChannelLogs`,
			request,
			{ cancelToken: cancelToken },
		);
	};

export const getTwilioServicesList = async (productId: string, subscriptionId: string, environment: string) => {
	return await axios.post(`/api/v1/${productId}/Twilio/ChannelLogs/${subscriptionId}/GetChatServices`, {
		accountSid: environment,
	});
};

export const getTwilioChannelLogJson =
	(channelSid: string, serviceSid: string, productId: string, subscriptionId: string, accountSid: string) =>
	async (): Promise<AxiosResponse<LogEvent[]>> => {
		return await axios.get(
			`/api/v1/${productId}/Twilio/ChannelLogs/${subscriptionId}/${accountSid}/${serviceSid}/${channelSid}/GetChannelLogJson`,
		);
	};
